import React, { Suspense } from "react";
import { Spin } from "antd";
import { useParams } from "react-router-dom";
const CalendarPeriodsContainer = React.lazy(
  () => import("../../../modules/Calendars/components/calendarPeriods")
);

const CalendarPeriodsPage = () => {
  const params = useParams<{ slug }>();

  return (
    <Suspense fallback={<Spin />}>
      <CalendarPeriodsContainer calendarSlug={params.slug} />
    </Suspense>
  );
};

export default CalendarPeriodsPage;
